import { formatMoney } from "@/utils/StringUtils";
import { Skeleton, styled } from "@mui/material";
import { useCheckoutCartInfo } from "../../hooks/useCheckoutCartInfo";

const TotalContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  color: theme.vars.palette.text.primary,
}));

const TotalRow = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: "14px",
  color: theme.vars.palette.text.primary,
}));

const TotalRowBold = styled(TotalRow)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 600,
  marginTop: "4px",
  paddingTop: "12px",
  color: theme.vars.palette.text.primary,
  borderTop: `1.2px solid ${theme.vars.palette.text.primary}`,
}));

const PriceGroup = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 8,

  ".strike": {
    color: theme.vars.palette.text.primary,
    opacity: 0.5,
    textDecoration: "line-through",
  },
}));

export const CartTotal = () => {
  const info = useCheckoutCartInfo();

  const {
    subtotal,
    estimatedShipping,
    originalShippingFees,
    estimatedTax,
    // originalEstimatedTax,
    amountToCharge,
    items,
    deliveryEstimate,
    checkoutSummaryLoading,
    serviceFee,
    originalServiceFee,
    originalTotal,
  } = info;

  if (checkoutSummaryLoading) {
    return (
      <TotalContainer>
        <TotalRow>
          <Skeleton width={"30%"} />
          <Skeleton width={"20%"} />
        </TotalRow>
        <TotalRow>
          <Skeleton width={"34%"} />
          <Skeleton width={"15%"} />
        </TotalRow>
        <TotalRow>
          <Skeleton width={"25%"} />
          <Skeleton width={"15%"} />
        </TotalRow>
        <TotalRow>
          <Skeleton width={"20%"} />
          <Skeleton width={"15%"} />
        </TotalRow>
        <TotalRowBold>
          <Skeleton width={"15%"} />
          <Skeleton width={"25%"} />
        </TotalRowBold>
      </TotalContainer>
    );
  }

  return (
    <TotalContainer>
      <TotalRow>
        <span>
          Subtotal ({items?.length} item{items?.length === 1 ? "" : "s"})
        </span>
        <span>{formatMoney(subtotal)}</span>
      </TotalRow>
      <TotalRow>
        <span>Shipping fee ({`${deliveryEstimate || "2-5 days"}`})</span>
        <PriceGroup>
          {typeof originalShippingFees === "number" &&
          originalShippingFees > estimatedShipping + 0.001 ? (
            <span className="strike">{formatMoney(originalShippingFees)}</span>
          ) : null}
          <span>{formatMoney(estimatedShipping)}</span>
        </PriceGroup>
      </TotalRow>
      <TotalRow>
        <span>Estimated tax</span>
        <PriceGroup>
          <span>{formatMoney(estimatedTax)}</span>
        </PriceGroup>
      </TotalRow>
      <TotalRow>
        <span>Service fee</span>
        <PriceGroup>
          {typeof originalServiceFee === "number" &&
          originalServiceFee > serviceFee ? (
            <span className="strike">{formatMoney(originalServiceFee)}</span>
          ) : null}
          <span>{formatMoney(serviceFee)}</span>
        </PriceGroup>
      </TotalRow>
      <TotalRowBold>
        <span>Total</span>
        <PriceGroup>
          {typeof originalTotal === "number" &&
          originalTotal > amountToCharge ? (
            <span className="strike">{formatMoney(originalTotal)}</span>
          ) : null}
          <span>{formatMoney(amountToCharge)}</span>
        </PriceGroup>
      </TotalRowBold>
    </TotalContainer>
  );
};
